import { useEffect } from 'react';
import { SegmentedControl } from '@mantine/core';
import dayjs from 'dayjs';

import { useLocal } from '../../lib/local/use-local';

export const SwitchLang = () => {
  const [local, setLang] = useLocal();

  useEffect(() => {
    const lang = local === 'hy' ? 'hy-am' : local;
    dayjs.locale(lang);
  }, [local]);

  return (
    <SegmentedControl
      fullWidth
      size="md"
      data={[
        { value: 'hy', label: 'Arm' },
        { value: 'en', label: 'Eng' },
        { value: 'ru', label: 'Rus' },
      ]}
      value={local}
      onChange={(v: 'ru' | 'en' | 'hy') => setLang(v)}
    />
  );
};
